import color from "@material-ui/core/colors/amber";
import Button from "../common/Button";

export const darkTheme = {
    palette: {
        type: 'dark', // Switching the dark mode on is a single property value change.
    },
};

export const lightTheme = {
    palette: {
        primary: {
            main: '#FF5200',
        },
        secondary: {
            light: '#5f5fc4',
            main: 'rgba(255, 255, 255, 0.5)',
            dark: '#001064',
            contrastText: '#030303',
        },
    },
    typography: {
        useNextVariants: true,
    },
    overrides: {
        Button: {
            root: {
                color: 'black',
                backgroundColor: '#F97316',
            },
        },
    },
};
